import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBomb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBomb"><Path d="M18 1H16V4H18V1Z" fill="currentColor"/><Path d="M22.4142 3L21 1.58579L18.5858 4L20 5.41421L22.4142 3Z" fill="currentColor"/><Path d="M18.4142 7L17 5.58579L14.9056 7.68014C13.551 6.62708 11.8487 6 10 6C5.58172 6 2 9.58172 2 14C2 18.4183 5.58172 22 10 22C14.4183 22 18 18.4183 18 14C18 12.1513 17.3729 10.449 16.3199 9.09436L18.4142 7Z" fill="currentColor"/><Path d="M20 6V8H23V6H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBomb;
